import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import { CLEAR_READ_STATUS } from "../../../store/activity-center-actions";
import ClientActivityAnchor from "@Shared/components/client-activity/client-activity-anchor.vue";
import EmptyMessage from "./empty-message";
import ActivityLoader from "./activity-loader";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientActivitiesContainer",
  components: {
    ClientActivityAnchor,
    EmptyMessage,
    ActivityLoader,
    ProfileAvatar
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState("ActivityCenterStore", {
    activities(state) {
      return state.activities.byId || {};
    }
  })), {}, {
    noActivities() {
      return _Object$keys(this.activities).length === 0;
    },
    sortedActivities() {
      var _context;
      return _sortInstanceProperty(_context = _Object$values(this.activities)).call(_context, (a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
    }
  }),
  beforeDestroy() {
    this.CLEAR_READ_STATUS({
      type: "activities"
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ActivityCenterStore", [CLEAR_READ_STATUS])), {}, {
    formatTimeAgo(value) {
      return this.$options.filters.formatTimeAgo(value);
    }
  })
});